export const SELECT_REPORTING_PERIOD = 'Please select the reporting period to view the data';
export const NO_REPORTING_DATA = 'There is no feedback report for this month';